import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading, AccuracyBar } from "@/components/ui-kit";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ArrowUpRight } from "lucide-react";

export default function Students() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/tutor/students").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;

  return (
    <div className="animate-fade-up">
      <PageHeader title="Students" subtitle="All students across JMSS and Selective programs." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((s) => (
          <Link key={s.id} to={`/tutor/students/${s.id}`} data-testid={`student-card-${s.id}`}
            className="ember-card ember-card-hover p-5">
            <div className="flex items-center gap-3">
              <Avatar className="h-12 w-12">
                <AvatarImage src={s.avatar_url || undefined} />
                <AvatarFallback className="bg-[#EDE9FE] text-[#5B21B6] font-bold">{s.name.split(" ").map((x) => x[0]).join("")}</AvatarFallback>
              </Avatar>
              <div className="min-w-0 flex-1">
                <div className="truncate font-heading font-bold text-[#1E1B2E]">{s.name}</div>
                <div className="truncate text-xs text-[#948EAB]">{s.program_name}</div>
              </div>
              <ArrowUpRight className="h-4 w-4 text-[#C4B5FD]" />
            </div>
            <div className="mt-4 flex items-center justify-between text-xs font-semibold text-[#524B6B]">
              <span>Avg accuracy</span>
              <span className="text-[#1E1B2E]">{s.average != null ? `${s.average}%` : "—"}</span>
            </div>
            <div className="mt-1.5"><AccuracyBar pct={s.average || 0} /></div>
            <div className="mt-3 text-xs text-[#948EAB]">{s.completed} completed assessment{s.completed === 1 ? "" : "s"}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
